export default {
      id: "icon-phone-usage",
      viewBox: "0 0 24 23",
      url: "../icon/" + "icons.svg#icon-phone-usage",
      toString: function () {
        return this.url;
      }
    }